module.exports = __webpack_public_path__ + "static/media/DSCF9013.645a1d56.JPG";